import React from 'react'
import { withRouter } from 'react-router-dom'

import { FeatureBottom } from './FeatureBottom'

import { isAnyPartOfElementInViewport } from '../../actions/actions'

class YourPlan extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      listenerComplete: false
    }
    this.handleScroll = this.handleScroll.bind(this)
  }

  componentDidMount() {
    this.handleScroll(null)
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll(event) {
    if (this.state.listenerComplete) {
      return
    }

    const itms = document.querySelectorAll('.section:not(.has-been-viewed)')

    if (itms.length <= 0) {
      this.setState({ ...this.state, listenerComplete: true })

      return
    }

    itms.forEach(selectedEle => {
      //console.log(selectedEle, this.isAnyPartOfElementInViewport(selectedEle))
      if (isAnyPartOfElementInViewport(selectedEle)) {
        selectedEle.classList.add('has-been-viewed')
      }
    })
  }

  render() {
    return (
      <div>
        <div className="container">
          <div className="row">
            <h2 className="page-title">The CareerExplorer Advantage</h2>
          </div>
        </div>
        <div
          className="title-block-bar"
          style={{ paddingTop: '75px', backgroundColor: '#1DA7E0' }}>
          <div className="container">
            <img
              src="/images/www/new/advantage/CareerExploration-HeaderImg.svg"
              style={{ maxWidth: '30%', zIndex: '100', position: 'relative' }}
              className="pull-right"
            />
            <p style={{ fontSize: '1.2rem' }}>
              Today, only 70% of high school seniors will go on to college, and of those
              40% will not graduate within 5 years. The CareerExplorer can help every
              student make a plan for success, not just those who are college bound.
              Helping every student plan for success is the foundation of the
              CareerExplorer advantage.
            </p>
          </div>
        </div>

        <div className="section">
          <div className="container" style={{ paddingTop: '25px' }}>
            <div className="row">
              <div className={'col-sm-5'}>
                <h3>
                  <b>More engaging</b>.<br /> Simple as that.
                </h3>
                <p style={{ color: ' #000', fontSize: '1rem' }}>
                  The CareerExplorer was designed from the ground up with the end user in
                  mind. Throughout the system, you will find an easy to understand
                  presentation with engaging graphics and an intuitive interface. Plus,
                  our responsive design makes the system useable on desktop and mobile
                  devices.
                </p>
              </div>
              <div className="col-sm-7">
                <img
                  src="/images/www/new/advantage/CareerExploration-UsersInterface.svg"
                  className="img-responsive image-grow"
                />
              </div>
            </div>
          </div>
        </div>

        <div
          className="section title-block-bar"
          style={{ paddingTop: '75px', backgroundColor: '#eef6fb' }}>
          <div className="container">
            <div className="row">
              <div className="col-sm-4">
                <img
                  src="/images/www/new/advantage/CareerExploration-Standards.svg"
                  className="img-responsive image-grow"
                />
              </div>
              <div className={'col-sm-8'}>
                <h3>
                  Finally, a system <b>aligned to grants and standards</b>.
                </h3>
                <p style={{ color: ' #000', fontSize: '1rem' }}>
                  The CareerExplorer system uses data from a variety of reliable and
                  objective sources, including O*NET. By aligning with these sources, we
                  make it easy to comply with grant requirements and meet state learning
                  standards.
                </p>
                <ul>
                  <li>Regionalized data is aligned with Perkins 5</li>
                  <li>Pre-defined lessons align with state standards</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="section">
          <div
            className="container"
            style={{ paddingTop: '25px', paddingBottom: '25px' }}>
            <div className="row">
              <div className={'col-sm-7'}>
                <h3>
                  The data you need, <b>Customized</b> how you need it.
                </h3>
                <p style={{ color: ' #000', fontSize: '1rem' }}>
                  The CareerExplorer was designed from the ground up with the end user in
                  mind. Throughout the system, you will find an easy to understand
                  presentation with engaging graphics and an intuitive interface. Plus,
                  our responsive design makes the system useable on desktop and mobile
                  devices.
                </p>
                <ul>
                  <li>
                    Use one of the pre-built lessons in the system, or create your own.
                  </li>
                  <li>
                    Approval queue allows you to accept student work, or return it back to
                    them with comments for improvement.
                  </li>
                  <li>At-a-glance reporting to easily see class and student progress</li>
                  <li>
                    Completed lessons can easily be downloaded as PDF for offline storage
                  </li>
                </ul>
              </div>
              <div className="col-sm-5">
                <img
                  src="/images/www/new/advantage/CareerExploration-Workflow.svg"
                  className="img-responsive image-grow"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="section title-block-bar" style={{ backgroundColor: '#eef6fb' }}>
          <div className="row">
            <div className="container" style={{ marginBottom: '40px' }}>
              <div className="col-sm-5">
                <img
                  src="/images/www/new/advantage/CareerExploration-Accountability.svg"
                  className="img-responsive image-grow"
                />
              </div>
              <div className={'col-sm-7'}>
                <h3>
                  Who knew <b>accountability</b> could <b>be this easy</b>?
                </h3>
                <p style={{ color: ' #000', fontSize: '1rem' }}>
                  Keep tabs on student progress as they progress through the activities in
                  the system. From our high-level dashboard report to activity specific
                  reports to user specific reports, you can easily drill down to find the
                  data you need.
                </p>
                <ul>
                  <li>
                    Reports are easily generated to show just the users or cohorts you
                    need to report on
                  </li>
                  <li>
                    Simple reporting format simply and visually shows class progress
                  </li>
                  <li>Easily exportable to PDF, CSV, and Microsoft Excel</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="section">
          <div
            className="container"
            style={{ paddingTop: '25px', paddingBottom: '25px' }}>
            <div className="row">
              <div className={'col-sm-7'}>
                <h3>
                  <b>Safe</b> and <b>Secure</b>
                </h3>
                <p style={{ color: ' #000', fontSize: '1rem' }}>
                  The CareerExplorer was designed from the ground up with the end user in
                  mind. Throughout the system, you will find an easy to understand
                  presentation with engaging graphics and an intuitive interface. Plus,
                  our responsive design makes the system useable on desktop and mobile
                  devices.
                </p>
                <ul>
                  <li>256 bit SSL Encryption protects data transfer</li>
                  <li>Compliant with the student privacy pledge</li>
                  <li>
                    Users own their data, and can take it to other CareerExplorer
                    deployments in other schools and/or states.
                  </li>
                </ul>
              </div>
              <div className="col-sm-5">
                <img
                  src="/images/www/new/advantage/CareerExploration-Secure.svg"
                  className="img-responsive image-grow"
                />
              </div>
            </div>
          </div>
        </div>

        <div
          className="section title-block-bar"
          style={{ paddingTop: '75px', backgroundColor: '#1DA7E0' }}>
          <div className="container">
            <div className="row">
              <div className="col-sm-2">
                <img
                  src="/images/www/new/advantage/CareerExploration-Quote.svg"
                  className="img-responsive"
                />
              </div>
              <div className={'col-sm-10'}>
                <p style={{ fontSize: '1.1rem' }}>
                  {' '}
                  As our district continues to embrace technology and enhance our student
                  engagement, as a middle school counselor, I see PA Career Zone being a
                  large part of our success.
                </p>
                <p
                  className="text-right"
                  style={{ fontSize: '.8rem', fontWeight: 'bold' }}>
                  John Lario
                  <br />
                  School Counselor
                  <br />
                  Yough Intermediate Middle School
                </p>
              </div>
            </div>
          </div>
        </div>

        <FeatureBottom state={this.props.match.params.state} />
      </div>
    )
  }
}

export default withRouter(YourPlan)
